import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    data: [],
  },

  mutations: {
    setData(state, payload) {
      state.data = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    read({ commit, state }, filters = null) {
      commit('setLoading', true)
      axios.admin
        .get('bands',{
          params: {
            ...filters
          }
        })
        .then(r => {
          commit('setData', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, bands) {
      axios.admin
          .put('bands/' + bands.iso + '/' + bands.band)
          .then(() => {
            dispatch('read')
          })
    },
  }
}
